const showNewCartMsg = () => {
	if (document.querySelectorAll(".inventoryStatusMsg").length > 0) {
		showMsg();
	} else {
		let msg = document.getElementById("limited-avail-msg");
		if (msg) {
			msg.remove();
		}
	}
};

const showMsg = () => {
	let message = document.createElement("div");
	message.id = "limited-avail-msg";
	message.style.display = 'block';
	message.style.marginTop = '15px';
	message.innerHTML = `<div style="display: flex; align-items: center;">
							<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
								viewBox="0 0 32 32" style="height: 32px; width: 32px; display: inline-block;" xml:space="preserve">
								<style type="text/css">
									.stb0{stroke:#000000;stroke-miterlimit:10;}
									.stw1{fill:#FFFFFF;}
								</style>
								<circle id="Clock_Face" class="stb0" cx="16" cy="16" r="15"/>
								<path id="Minute_Hand" class="stw1" d="M16.4,16.5c-0.3,0.2-0.6,0.2-0.8-0.1L8.8,8.3C8.5,8,8.6,7.7,8.8,7.5c0.3-0.2,0.6-0.2,0.8,0.1
									l6.8,8.1C16.7,15.9,16.6,16.2,16.4,16.5z"/>
								<path id="Hour_Hand" class="stw1" d="M22.8,12.1c0.2,0.3,0.1,0.7-0.2,0.8l-6.2,3.6c-0.3,0.2-0.7,0.1-0.8-0.2s-0.1-0.7,0.2-0.8
									l6.2-3.6C22.2,11.7,22.6,11.8,22.8,12.1z"/>
								<path id="_x39_" class="stw1" d="M2.7,15.5H6c0.3,0,0.5,0.2,0.5,0.5S6.3,16.5,6,16.5H2.7c-0.3,0-0.5-0.2-0.5-0.5S2.4,15.5,2.7,15.5z"/>
								<path id="_x36_" class="stw1" d="M16.5,26v3.4c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V26c0-0.3,0.2-0.5,0.5-0.5S16.5,25.7,16.5,26z"/>
								<path id="_x33_" class="stw1" d="M26,15.5h3.4c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H26c-0.3,0-0.5-0.2-0.5-0.5S25.7,15.5,26,15.5z"/>
								<path id="_x31_2" class="stw1" d="M16.5,2.7V6c0,0.3-0.2,0.5-0.5,0.5S15.5,6.3,15.5,6V2.7c0-0.3,0.2-0.5,0.5-0.5S16.5,2.4,16.5,2.7z"/>
							</svg>

							<h2 style="display: inline-block; vertical-align: middle; color: #d73d3c; margin: 0 0 0 10px;">
								An item in your cart is selling quickly!
							</h2>
						</div>`;
	let header = document.getElementsByClassName("cartHeader")[0];
	header.appendChild(message);

	for (let i = 0; i < document.querySelectorAll(".inventoryStatusMsg").length; i++) {
		let productMessage = document.querySelectorAll(".inventoryStatusMsg")[i];
		let quanity =  document.querySelectorAll(".inventoryStatusMsg")[i].innerHTML.match(/\d+/)[0];
		if (quanity === '3') {
			productMessage.innerHTML = "Hurry, only 3 available!";
		} else if (quanity === '2') {
			productMessage.innerHTML = "Hurry, only 2 available!";
		} else if (quanity === '1') {
			productMessage.innerHTML = "Hurry, only 1 available!";
		}
	}
};

export { showNewCartMsg };